import React from 'react';
import PropTypes from 'prop-types';
import Description from 'ui/text/Description';

import { t } from 'i18n/index';

import {StyledDivider} from 'ui/StyledComponents/StyledDivider';

import SecretLocation from './SecretLocation';

const Location = ({ location, secret_location }) => {
  if (!location && !secret_location) return null;

  const mapUrl = location
    ? `https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&q=${encodeURIComponent(location)}`
    : null;

  return (
    <>
      <Description>{t('literal:location')}</Description>
      <StyledDivider />
      {secret_location ? (
        <SecretLocation location={location} />
      ) : (
        <div style={{ height: '200px', width: '100%', borderRadius: '8px', overflow: 'hidden'}}>
          <iframe
            width="100%"
            height="100%"
            style={{ border: 0 }}
            src={mapUrl}
            allowFullScreen
          ></iframe>
        </div>
      )}
    </>
  );
};

Location.propTypes = {
  location: PropTypes.string,
  secret_location: PropTypes.bool,
};

export default Location;
